import { useState, useRef } from "react";
import "./Contactus.scss";
import { Container, Dialog, DialogTitle, DialogContent, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid2";
import AtomButton from "../../atoms/button/button";
import { character, DotPatternBlue } from "../../helpers/constant/imageUrl";

import "./Contactform.scss";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "@emailjs/browser";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../firbase/firebase";

export default function Contactform() {
  const [result, setResult] = useState("");
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:484px)");


  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    remarks: "",
  });

  const [phoneError, setPhoneError] = useState("");
  const recaptchaRef = useRef(null);
  const [captchaReady, setCaptchaReady] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("");
    setPhoneError("");

    // Phone validation
    const digitsOnly = formData.phoneNumber.replace(/\D/g, "");
    if (!digitsOnly || digitsOnly.length < 10) {
      setPhoneError("Please enter a valid phone number");
      return;
    }

    if (!captchaReady) {
      setResult("Please complete the reCAPTCHA");
      return;
    }

    const token = recaptchaRef.current?.getValue();
    if (!token) {
      setResult("Please complete the reCAPTCHA");
      return;
    }

    setResult("Sending...");

    const templateParams = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      phoneNumber: formData.phoneNumber,
      email: formData.email,
      remarks: formData.remarks,
      "g-recaptcha-response": token,
    };

    try {
      // Optional tiny delay to avoid cold load issues
      await new Promise((res) => setTimeout(res, 200));

      // EmailJS send to admin
      await emailjs.send(
        "service_hwozqt9",
        "template_ldzxadk",
        templateParams,
        { publicKey: "PyFAouqZWBx5P0z7V" }
      );

      // EmailJS auto-reply to user
      await emailjs.send(
        "service_hwozqt9",
        "template_w2p1fap",
        templateParams,
        { publicKey: "PyFAouqZWBx5P0z7V" }
      );

      logEvent(analytics, "contactus_btn_submit", {
              content_id: "contactus_btn_submit",
              source: "contactus",
            });

      setResult("Form Submitted Successfully");
      setOpen(true);

      // reset form
      setFormData({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        remarks: "",
      });

      // reset captcha
      recaptchaRef.current.reset();
      setCaptchaReady(false);
    } catch (err) {
      console.error("EmailJS Error:", err);
      setResult("Submission failed. Please try again.");
    }
  };

  const handleClose = () => setOpen(false);

  return (
    <div className="conversation-section" style={{ marginTop: "9%" }}>
      <form onSubmit={onSubmit}>
        <Container className="container">
          <div className="conversation-form">
            <div className="patternImg">
               <img  loading="lazy"
                src={DotPatternBlue}
                alt="dotpattern"
                className="Dotpattern"
                 
              />
            </div>

            <Grid container spacing={3} alignItems="center">
              <Grid size={{ xs: 12, md: 4 }}>
                <h4>Let's Have a Conversation</h4>
                <p>
                  Please leave your message here so we can take the conversation
                  forward.
                </p>
              </Grid>

              <Grid size={{ xs: 12, md: 8 }}>
                <div className="white-card">
                  <Grid container columnSpacing={{ xs: 1, sm: 2, md: 5 }}>
                    {/* First Name */}
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="inputfield">
                        <label htmlFor="firstname" className="text">
                          First Name
                        </label>
                        <input
                          type="text"
                          name="firstName"
                          placeholder="Ex: John"
                          required
                          value={formData.firstName}
                          onChange={(e) =>
                            setFormData((p) => ({
                              ...p,
                              firstName: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </Grid>

                    {/* Last Name */}
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="inputfield">
                        <label htmlFor="lastname" className="text">
                          Last Name
                        </label>
                        <input
                          type="text"
                          name="lastName"
                          placeholder="Ex: Doe"
                          required
                          value={formData.lastName}
                          onChange={(e) =>
                            setFormData((p) => ({
                              ...p,
                              lastName: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </Grid>

                    {/* Email */}
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="inputfield">
                        <label htmlFor="email" className="text">
                          Email
                        </label>
                        <input
                          type="email"
                          name="email"
                          placeholder="Ex: john@example.com"
                          required
                          value={formData.email}
                          onChange={(e) =>
                            setFormData((p) => ({
                              ...p,
                              email: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </Grid>

                    {/* Phone Number */}
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="inputfield">
                        <label htmlFor="phoneNumber" className="text">
                          Phone Number
                        </label>
                        <PhoneInput
                          inputProps={{
                            name: "phoneNumber",
                            id: "phoneNumber",
                            required: true,
                          }}
                          country="in"
                          value={formData.phoneNumber}
                          onChange={(phone) =>
                            setFormData((p) => ({ ...p, phoneNumber: phone }))
                          }
                          inputStyle={{
                            width: "100%",
                            height: "35px",
                            borderTop: "none",
                            borderRight: "none",
                            borderLeft: "none",
                            borderBottom: "1px solid #ccc",
                            borderRadius: 0,
                            outline: "none",
                            paddingLeft: "48px",
                          }}
                          buttonStyle={{
                            borderTop: "none",
                            borderLeft: "none",
                            borderRight: "1px solid #ccc",
                            borderBottom: "1px solid #ccc",
                            borderRadius: 0,
                            backgroundColor: "transparent",
                          }}
                        />
                        {phoneError && (
                          <span style={{ color: "red", fontSize: "0.8rem" }}>
                            {phoneError}
                          </span>
                        )}
                      </div>
                    </Grid>

                    {/* Remarks */}
                    <Grid size={{ xs: 12 }}>
                      <div className="inputfield">
                        <label htmlFor="remarks" className="text">
                          Remarks
                        </label>
                        <textarea
                          name="remarks"
                          placeholder="Write your purpose within (250 words)"
                          required
                          value={formData.remarks}
                          onChange={(e) =>
                            setFormData((p) => ({
                              ...p,
                              remarks: e.target.value,
                            }))
                          }
                          style={{ height: "50px" }}
                        />
                      </div>
                    </Grid>

                    {/* Google reCAPTCHA */}
                    <Grid size={{ xs: 12, md: 6 }}>
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6LeL-SAsAAAAAKnxtWk0ZXvCvJ1bvn-PYW0vE7je"
                        size={isMobile ? "compact" : "normal"}
                        onChange={() => setCaptchaReady(true)}
                      />
                    </Grid>

                    {/* Submit Button */}
                    <Grid size={{ xs: 12 }} className="mt-10">
                      <AtomButton
                        name="primaryButton"
                        color="info"
                        size="medium"
                        variant="contained"
                        type="submit"
                        disabled={!captchaReady}
                      >
                        Submit
                      </AtomButton>
                    </Grid>
                  </Grid>

                  {/* Result Message */}
                  <div style={{ marginTop: "1rem", color: "green" }}>
                    {result}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </form>

      {/* Success Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="success-popup">
           <img  loading="lazy"
            src={character}
            alt="Success"
            className="success-img"
             
          />
          <h3>Message Sent Successfully!</h3>
          <p>Sit back and relax. We will get back to you shortly.</p>
        </DialogContent>
      </Dialog>
    </div>
  );
}
